import { Injectable } from '@angular/core';

declare global {
    interface Window {
        dataLayer?: any[];
        gtag?: (...args: any[]) => void;
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {
    private readonly GA_MEASUREMENT_ID = 'G-YPZQ0RRTP6';
    private cachedClientId: string | null = null;

    load(): void {
        if (typeof window === 'undefined' || window.gtag) return;

        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.GA_MEASUREMENT_ID}`;
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer!.push(arguments); };

        window.gtag('js', new Date());
        
        window.gtag('config', this.GA_MEASUREMENT_ID);
    }

    async getClientId(): Promise<string | null> {
        if (this.cachedClientId) return this.cachedClientId;
        if (typeof window === 'undefined' || !window.gtag) return null;

        return new Promise((resolve) => {
            
            const timeout = setTimeout(() => resolve(null), 1500);

            window.gtag!('get', this.GA_MEASUREMENT_ID, 'client_id', (clientId: string) => {
                clearTimeout(timeout);
                this.cachedClientId = clientId;
                resolve(clientId);
            });
        });
    }
}